/*!
 *  (c)(r) 2008-2021 IT-Service Robert Frunzke
 */

import { arr_inArray } from './util.js';
import { startProgress, stopProgress } from './progress-util.js';
import { mj } from './page-mj.js';
import { jQuery } from '../other/jquery-hooked.js';
import { MDTrees } from './tree-data.js';


function SearchRequest( state ) {
	// see MVSearch.getSearchRequest();
	var defaults = {
		'fulltext': null,					// null or string containing the fulltext query
		'fulltext_multiline': false,
		'constraints': [],
		'mode': null,						// null, 'browse', 'filter'
		'colors': ['','',''],
		'options': [],
		'in_trees': [],
		'in_categories': [],
		'not_in_trees': [],
		'conjunct_mode_trees': [],
	};
	// init request state data
	// -> ensure _state becomes independent object (a deep copy of defaults plus provided state)
	//this._state = $.extend( true, {}, defaults, state||{} );
	this._state = Object.assign( {}, defaults, state||{} );
	if( this._state.hasOwnProperty('_transient_title') ) {
		this._transient_title = this._state._transient_title;
		delete this._state._transient_title;
	} else {
		this._transient_title = '';
	}
	if( this._state.hasOwnProperty('_object_id') ) {
		this._object_id = this._state._object_id;
		delete this._state._object_id;
	} else {
		this._object_id = 0;
	}
	if( this._state.hasOwnProperty('_additional_data') ) {
		this._additional_data = this._state._additional_data;
		delete this._state._additional_data;
	} else {
		this._additional_data = "";
	}
}

SearchRequest.createOptionKey = function( opt_cfg ) {
	return opt_cfg.meta_id+':'+opt_cfg.type;
};

SearchRequest.prototype = {
	getSerializedState: function( pretty ) {
		return JSON.stringify(this._state,null,pretty?' ':null);
	},
	getState: function() {
		return this._state;
	},
	getTransientState: function() {
		return Object.assign( {}, this._state, { _transient_title:this._transient_title } );
	},

	setTransientTitle: function( title ) {
		this._transient_title = title;
	},
	getTransientTitle: function() {
		return this._transient_title;
	},

	createCopy: function() {
		var new_sr = new SearchRequest(this._state);
		new_sr.setTransientTitle(this.getTransientTitle());
		new_sr.setObjectId(this.getObjectId());
		new_sr.setAdditionalData(this.getAdditionalData());
		return new_sr;
	},
	setFulltextQuery: function( ftq, ftm ) {
		this._state.fulltext = ftq;
		this._state.fulltext_multiline = ftm;
	},
	setConstraints: function( constraints ) {
		this._state.constraints = constraints;
	},
	hasConstraints: function() {
		return this._state.constraints.length!==0;
	},
	removeConstraint: function( constraint ) {
		var l = this._state.constraints.length;
		for( var i=0; i<l; ++i ) {
			if( this._state.constraints[i]==constraint ) {
				this._state.constraints.splice(i,1);
				return true;
			}
		}
		return false;
	},
	setBrowseMode: function( mode ) {
		this._state.mode = mode;
	},
	removeColorByCode: function( code ) {
		var cl = this._state.colors.length, i;
		for( i=0; i<cl; ++i ) {
			if( this._state.colors[i]===code ) this._state.colors[i] = '';
		}
	},
	removeColorByIndex: function( index ) {
		if( index >= 0 && index < this._state.colors.length ) this._state.colors[index] = '';
	},
	removeColors: function() {
		this._state.colors = ['','',''];
	},
	removeOptionByKey: function( key ) {
		var ol = this._state.options.length, i;
		for( i=0; i<ol; ) {
			if( key===SearchRequest.createOptionKey(this._state.options[i].config) ) {
				this._state.options.splice(i,1);
				--ol;
			} else {
				++i;
			}
		}
	},
	setOption: function( config, value, display_value ) {
		var skey = SearchRequest.createOptionKey(config);
		var oobj = { config:config, value:value, display_value:display_value };
		var ol = this._state.options.length, i;
		for( i=0; i<ol; ) {
			if( skey===SearchRequest.createOptionKey(this._state.options[i].config) ) {
				this._state.options[i] = oobj;
				return;
			}
		}
		this._state.options.push(oobj);
	},
	removeOptions: function() {
		this._state.options = [];
	},
	addFlatCategoriesList: function( categories ) {
		var cl = categories.length;
		for( var i=0; i<cl; ++i ) {
			var cat_id = categories[i][1],
				tree_id = cat_id==-1 ? 1 : ( categories[i][0] || MDTrees.getTreeIdFromCategoryId(cat_id) );
			if( tree_id!==null ) {
				if( cat_id==0 ) {
					this._state.not_in_trees.push(tree_id);
				} else {
					if( arr_inArray(tree_id,this._state.in_trees)===-1 ) this._state.in_trees.push(tree_id);
					this._state.in_categories.push(cat_id);
				}
			}
		}
	},
	getFlatCategoriesList: function() {
		var fc = this._state.in_categories,
			fcl = fc.length,
			fnit = this._state.not_in_trees,
			fnitl = fnit.length,
			c = [],
			i;
		for( i=0; i<fcl; ++i ) c.push( [ fc[i]==-1 ? 1 : MDTrees.getTreeIdFromCategoryId(fc[i]), fc[i] ] );
		for( i=0; i<fnitl; ++i ) c.push( [ fnit[i], 0 ] );
		return c;
	},
	setCategoryXFilter: function( filter ) {
		this._state.in_trees = filter.hasOwnProperty('in_trees') ? filter.in_trees.slice(0) : [];
		this._state.in_categories = filter.hasOwnProperty('categories') ? filter.categories.slice(0) : [];
		this._state.not_in_trees = filter.hasOwnProperty('not_in_trees') ? filter.not_in_trees.slice(0) : [];
	},
	getCategoryXFilter: function() {
		return {
			in_trees: this._state.in_trees.slice(0),
			categories: this._state.in_categories.slice(0),
			not_in_trees: this._state.not_in_trees.slice(0),
		};
	},
	removeFromCategoriesFilter: function( tree_id, cat_ids ) {
		if( cat_ids && cat_ids.length!==0 ) {
			this._state.in_categories = this._state.in_categories.filter( function(c) {
				return arr_inArray(c,cat_ids)===-1;
			} );
			if( arr_inArray(0,cat_ids)!==-1 ) {
				this._state.not_in_trees = this._state.not_in_trees.filter( function(t) {
					return t != tree_id;
				} );
			}
			// TODO: update in_trees too ???
		}
	},
	removeCategoriesFilter: function() {
		this._state.in_trees = [];
		this._state.in_categories = [];
		this._state.not_in_trees = [];
		this._state.conjunct_mode_trees = [];
	},
	hasCategoriesFilter: function() {
		return this._state.in_trees.length!==0 || this._state.in_categories.length!==0 || this._state.not_in_trees.length!==0;
	},
	hasOptions: function() {
		return this._state.options.length!==0;
	},
	hasColors: function() {
		var cl = this._state.colors.length, i;
		if( cl!==0 ) {
			for( i=0; i<cl; ++i ) {
				if( this._state.colors[i]!=='' ) return true;
			}
		}
		return false;
	},
	normalize: function() {
		if( this._state.mode===null ) this._state.mode = 'browse';
		var cl = this._state.colors, i;
		if( cl<3 ) {
			for( i=cl; i<3; ++i ) this._state.colors.push('');
		}
		if( this._state.fulltext===null || this._state.fulltext==='' ) {
			if( this.hasCategoriesFilter() || this.hasOptions() || this.hasColors() ) this._state.fulltext = '*';
		}
	},
	deflateForURLRequest: function() {
		if( this._state.hasOwnProperty('options') ) {
			var so = this._state.options,
				sol = so.length,
				i;
			for( i=0; i<sol; ++i ) {
				var o = so[i];
				if( o.hasOwnProperty('display_value') ) delete o.display_value;
				if( o.hasOwnProperty('config') ) {
					var oc = o.config;
					if( oc.hasOwnProperty('title') ) delete oc.title;
					if( oc.hasOwnProperty('change') ) delete oc.change;
					if( oc.hasOwnProperty('config') ) delete oc.config;
				}
			}
		}
	},
	inflateCategories: function() {
		this._state.in_trees = [];
		var cl = this._state.in_categories.length;
		for( var i=0; i<cl; ++i ) {
			var cat_id = this._state.in_categories[i],
				tree_id = cat_id==-1 ? 1 : MDTrees.getTreeIdFromCategoryId(cat_id);
			if( tree_id!==null && arr_inArray(tree_id,this._state.in_trees)===-1 ) this._state.in_trees.push(tree_id);
		}
	},
	inflateOptions: function( query_title_cb, query_display_value_cb ) {
		// for each option: determine title and compute display_value
		if( this._state.hasOwnProperty('options') ) {
			var so = this._state.options,
				sol = so.length,
				i;
			for( i=0; i<sol; ++i ) {
				var o = so[i];
				var oc = o.hasOwnProperty('config') ? o.config : {};
				if( !oc.hasOwnProperty('title') ) {
					oc.title = query_title_cb(oc);
					if( oc.title===null ) oc.title = oc.meta_id+':'+oc.type;
				}
				if( !o.hasOwnProperty('display_value') ) {
					o.display_value = query_display_value_cb(oc,o.value);
					if( o.display_value===null ) o.display_value = o.value;
				}
			}
		}
	},
	withCategoriesInflated: function() {
		var new_sr = new SearchRequest(this._state);
		new_sr.setTransientTitle(this.getTransientTitle());
		new_sr.setObjectId(this.getObjectId());
		new_sr.setAdditionalData(this.getAdditionalData());

		// compute values of "in_trees" ...
		new_sr.inflateCategories();
		/*var flat_categories = new_sr.getFlatCategoriesList();
		new_sr.removeCategoriesFilter();
		new_sr.addFlatCategoriesList(flat_categories);*/

		return new_sr;
	},
	withCategoriesDeflated: function() {
		var tcl = this._state.in_categories.length,
			scat_hashes = {},
			done_hashes = {},
			result_categories = [],
			i;
		for( i=0; i<tcl; ++i ) scat_hashes[this._state.in_categories[i]] = 1;

		function _set_done_recurse( tree_id, cat_id ) {
			done_hashes[cat_id] = 1;
			MDTrees.foreachChildCategoryNodeOrdered(tree_id,cat_id,function( ccat_id, ccnode ) {
				if( scat_hashes.hasOwnProperty(ccat_id) ) _set_done_recurse(tree_id,ccat_id);
			});
		}

		function _set_done( tree_id, cat_id ) {
			done_hashes[cat_id] = 1;
			var all_descendants_selected = true;
			MDTrees.foreachDescendantCategoryNodeOrdered(tree_id,cat_id,function( ccat_id, ccnode ) {
				if( !scat_hashes.hasOwnProperty(ccat_id) ) {
					all_descendants_selected = false;
					return false;
				}
			});
			if( all_descendants_selected ) {
				MDTrees.foreachDescendantCategoryNodeOrdered(tree_id,cat_id,function( ccat_id, ccnode ) {
					done_hashes[ccat_id] = 1;
				});
			} else {
				MDTrees.foreachChildCategoryNodeOrdered(tree_id,cat_id,function( ccat_id, ccnode ) {
					_set_done_recurse(tree_id,ccat_id);
				});
			}
		}

		for( i=0; i<tcl; ++i ) {
			var cat_id = this._state.in_categories[i];
			if( !done_hashes.hasOwnProperty(cat_id) ) {
				if( cat_id==-1 ) {
					// pass "unknown" category without child traversal
					result_categories.push(cat_id);
				} else {
					// traverse category descendants ..
					var tree_id = MDTrees.getTreeIdFromCategoryId(cat_id);
					if( tree_id!==null ) {
						_set_done(tree_id,cat_id);
						result_categories.push(cat_id);
					}
				}
			}
		}
		var new_sr = new SearchRequest(this._state);
		new_sr.setCategoryXFilter( { in_trees:this._state.in_trees, categories:result_categories, not_in_trees:this._state.not_in_trees } );
		new_sr.setTransientTitle(this.getTransientTitle());
		new_sr.setObjectId(this.getObjectId());
		new_sr.setAdditionalData(this.getAdditionalData());
		return new_sr;
	},
	normalized: function() {
		var new_sr = new SearchRequest(this._state);
		new_sr.normalize();
		new_sr.setTransientTitle(this.getTransientTitle());
		new_sr.setObjectId(this.getObjectId());
		new_sr.setAdditionalData(this.getAdditionalData());
		return new_sr;
	},
	deflatedForURLRequest: function() {
		var new_sr = new SearchRequest(this._state);
		new_sr.normalize();
		new_sr = new_sr.withCategoriesDeflated();
		new_sr.deflateForURLRequest();
		new_sr.setTransientTitle(this.getTransientTitle());
		new_sr.setObjectId(this.getObjectId());
		new_sr.setAdditionalData(this.getAdditionalData());
		return new_sr;
	},
	setObjectId: function(id) {
		this._object_id = id;
	},
	getObjectId: function() {
		return this._object_id;
	},
	setAdditionalData: function(data) {
		this._additional_data = data;
	},
	getAdditionalData: function() {
		return this._additional_data;
	},
};

function createSearchRequest( state ) {
	return new SearchRequest(state);
}

function unserializeSearchRequest( state_json ) {
	return createSearchRequest(JSON.parse(state_json));
}



function SearchResultInfo( state ) {
	// see mjMediaResultViewWidget listChanged
	var defaults = {
		'list_type':		'search',
		'list_id':			null,
		'list_count':		null,
		'tree_id':			null,
		'cat_id':			null,
		'category_count':	null
	};
	// init result state data
	// -> ensure _state becomes independent object (a deep copy of defaults plus provided state)
	//this._state = $.extend( true, {}, defaults, state||{} );
	this._state = Object.assign( {}, defaults, state||{} );
}

SearchResultInfo.prototype = {
	getType: function() {
		return this._state.list_type;
	},
	getId: function() {
		return this._state.list_id;
	},
	getState: function() {
		return this._state;
	},
	createCopy: function() {
		return new SearchResultInfo(this._state);
	},
};

function createSearchResultInfo( state ) {
	return new SearchResultInfo(state);
}

function queryListMediaIDs( list_id, callback ) {
	startProgress();
	jQuery.postJSON( mj.webroot+'json/media/list-getallmids', 'list_id='+encodeURIComponent(list_id)+'&filter_deleted=1', function(j) {
		stopProgress();
		if( j ) callback( j.media_ids, j.result_count );
	} );
}


export let MDIndex = function() {

	return {
		SearchRequest: SearchRequest,
		createSearchRequest: createSearchRequest,
		unserializeSearchRequest: unserializeSearchRequest,

		SearchResultInfo: SearchResultInfo,
		createSearchResultInfo: createSearchResultInfo,

		queryListMediaIDs: queryListMediaIDs,
	};

}(); // namespace MDIndex
